import { useState, useEffect } from "react";
import apiFactory from "../api";
import {openNotificationError, openNotificationSuccess} from "../utils/Utils";

export default function useStickerPacks() {
    const [packs, setPacks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 7, total: 0 });

    const fetchStickerPacks = async (page = 1, pageSize = 7) => {
        setLoading(true);
        try {
            const request = {
                page: page - 1,
                limit: pageSize
            }
            const res = await apiFactory.stickerPackApi.getStickerPacks(request);
            if (res?.status === 200) {
                setPacks(res.data.content);
                setPagination({
                    current: page,
                    pageSize,
                    total: res.data.totalElements,
                });
            }
        } catch {
            openNotificationError("Failed to fetch sticker packs");
        } finally {
            setLoading(false);
        }
    };

    const createPack = async (payload) => {
        const res = await apiFactory.stickerPackApi.createStickerPack(payload);
        if (res?.status === 200) {
            openNotificationSuccess("Sticker pack created");
            fetchStickerPacks(pagination.current, pagination.pageSize);
        }
    };

    const updatePack = async (payload) => {
        const res = await apiFactory.stickerPackApi.updateStickerPack(payload);
        if (res?.status === 200) {
            openNotificationSuccess("Sticker pack updated");
            fetchStickerPacks(pagination.current, pagination.pageSize);
        }
    };

    const deletePack = async (packId) => {
        const res = await apiFactory.stickerPackApi.deleteStickerPack(packId);
        if (res?.status === 200) {
            openNotificationSuccess("Sticker pack deleted");
            fetchStickerPacks(pagination.current, pagination.pageSize);
        }
    };

    useEffect(() => {
        fetchStickerPacks();
    }, []);

    return {
        packs,
        loading,
        pagination,
        fetchStickerPacks,
        createPack,
        updatePack,
        deletePack,
    };
}
